module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "blank"
  }, [_c('div', {
    staticClass: "credit-list"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/credit-header-bg.jpg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('ul', _vm._l((_vm.list), function(item, index) {
    return _c('li', {
      key: index
    }, [_c('a', {
      attrs: {
        "href": item.contentLink
      }
    }, [_c('img', {
      attrs: {
        "src": item.pictureLink
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "cl-r"
    }, [_c('h2', [_vm._v(_vm._s(item.contentName))]), _vm._v(" "), _c('p', {
      staticClass: "blue-one"
    }, [_vm._v(_vm._s(item.addContentOne))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.addContentTwo))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.addContentThree))])]), _vm._v(" "), _c('i')])])
  }), 0)]), _vm._v(" "), _c('loading', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }]
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-80a29060"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/creditlist.vue
// module id = 210
// module chunks = 0